import PropTypes from 'prop-types';
// @mui
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
// utils
import { fShortenNumber } from 'src/utils/format-number';
// components
import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

export default function AnalyticsTrafficBySite({ title, subheader, list, ...other }) {
  return (
    <Card >
      <Box display="grid" gap={ 2 } gridTemplateColumns="repeat(4, 1fr)"  >
        { list.map((site) => (
          <Paper key={ site.label } variant="" sx={ { py: 2.5, textAlign: 'center', borderRadius: 0, borderRight: (theme) => `2px solid #454545 ` } }>
            <Box display="flex" justifyContent="center" alignItems="center" gap={ 1 }>
              <Iconify icon={ site.icon } width={ 24 } />
              <Typography variant="subtitle2">{ site.label }</Typography>
            </Box>

            <Typography variant="h5" sx={ { mt: 1 } }>
              { fShortenNumber(site.total) }
            </Typography>

            <Typography variant="body2" sx={ { color: 'text.secondary' } }>
              { site.type }
              <Typography component="span" sx={ { color: 'info.main', ml: 0.5 } }>
                ↑ { site.growth }%
              </Typography>
            </Typography>
          </Paper>
        )) }
      </Box>
    </Card>
  );
}

AnalyticsTrafficBySite.propTypes = {
  list: PropTypes.array,
  subheader: PropTypes.string,
  title: PropTypes.string,
};
